import Dbm from "dbm";
import Website from "../../index.js";

//import * as PIXI from "pixi.js";
//import Matter from "matter-js";

export default class LoadingLevel extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        this.item.requireProperty("game", null);
        this.item.requireProperty("maxPercentage", 0);

        let layer = new PIXI.Container()
        this.item.requireProperty("pixiLayer", layer);

        let progressBar = new Website.game.graphics.ProgressBar();
        layer.addChild(progressBar.item.pixiLayer);
        this.item.setValue("progressBar", progressBar.item);

        progressBar.item.pixiLayer.x = Website.game.Sizes.CENTER_X-0.5*100;
        progressBar.item.pixiLayer.y = 140;

        this.item.requireProperty("state", "loading").addUpdate(this._getScopedCallFunctionCommand(this._stateChanged));
    }

    prepare() {
        //console.log("prepare");

        let text = Dbm.flow.externalObject(Dbm.getRepositoryItem("game").controller.getText("NIVÅ 1-1"));
        text.addProperty("alpha", 0);
        
        text.object.alpha = 0;
        text.object.position.x = Website.game.Sizes.CENTER_X-0.5*(text.object.width);
        text.object.position.y = 0.5*Website.game.Sizes.HEIGHT-0.5*(text.object.height);

        this.item.setValue("text", text.item)
        
        this.item.pixiLayer.addChild(text.object);

        /*
        let startLoaded = Dbm.flow.updatefunctions.logic.allAtValue(Dbm.loading.LoadingStatus.LOADED);
        startLoaded.addCheck(Website.game.getAsset("screens/start").properties.status);
        startLoaded.addCheck(Website.game.getAsset("screens/background").properties.status);
        Dbm.flow.runWhenMatched(startLoaded.output.properties.value, true, Dbm.commands.callFunction(this._startLoaded.bind(this)));

        let allLoaded = Dbm.flow.updatefunctions.logic.allAtValue(Dbm.loading.LoadingStatus.LOADED);

        this.loaders = [
            Website.game.getAsset("screens/start"),
            Website.game.getAsset("screens/select-character"),
            Website.game.getAsset("sounds/music"),
            Website.game.getAsset("sounds/interface"),
            Website.game.getAsset("sounds/game"),
            Website.game.getAsset("screens/gameover"),
            Website.game.getAsset("screens/level-completed"),
            Website.game.getAsset("screens/background"),
            Website.game.getAsset("screens/button"),
            Website.game.getAsset("screens/frame"),
            Website.game.getAsset("game-buttons"),
        ];

        let currentArray = this.loaders;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            allLoaded.addCheck(currentArray[i].properties.status);
        }
        
        Dbm.flow.runWhenMatched(allLoaded.output.properties.value, true, Dbm.commands.callFunction(this._loaded.bind(this)));
        */
    }

    start() {
        this.item.state = "loading";
        this.item.progressBar.animationLayer.scale = 1;
        this.item.progressBar.animationLayer.alpha = 0;
        this.item.progressBar.animationLayer.properties.alpha.animateValue(1, 0.5);

        let world = Math.floor((this.item.game.level-1)/4)+1;
        let step = ((this.item.game.level-1)%4)+1;

        this.item.text.object.text = "NIVÅ " + world + "-" + step;
        this.item.text.object.position.x = Website.game.Sizes.CENTER_X-0.5*(this.item.text.object.width);
        this.item.text.object.position.y = 0.5*Website.game.Sizes.HEIGHT-0.5*(this.item.text.object.height);
        this.item.text.alpha = 0;
        this.item.text.properties.alpha.animateValue(1, 0.3);

        this.item.properties.state.delayValue("loaded", 1.2); //MEDEBUG

        this.item.maxPercentage = 0;
        this.item.properties.maxPercentage.animateValue(1, 1.2);
    }

    _loaded() {
        //console.log("_loaded");

        this.item.state = "loaded";
    }

    _stateChanged() {
        if(this.item.state === "outroDone") {
            this.item.game.controller.changeScreen("gamePlay");
        }
        if(this.item.state === "loaded") {
            this.item.progressBar.animationLayer.properties.scale.animateValue(1.2, 0.3);
            this.item.progressBar.animationLayer.properties.scale.addAddionalAnimation(1.2, 0.5, 0.3, 0.3);
            this.item.progressBar.animationLayer.properties.alpha.animateValue(0, 0.2, 0.4);

            this.item.text.properties.alpha.animateValue(0, 0.3);
            
            this.item.properties.state.delayValue("outroDone", 1.2);
        }
    }

    update(aTime, aDelta) {

        /*
        let loadedLoaders = 0;

        let currentArray = this.loaders;
        let currentArrayLength = currentArray.length;
        for(let i = 0; i < currentArrayLength; i++) {
            if(currentArray[i].status === Dbm.loading.LoadingStatus.LOADED) {
                loadedLoaders++;
            }
        }
        
        */

        let percentage = this.item.maxPercentage; //loadedLoaders/(currentArrayLength);
        

        this.item.progressBar.percentage = percentage;
        this.item.progressBar.controller.update(aTime, aDelta);
    }

    stop() {
        
    }
}